<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="flex justify-content-between surface-100">
            <div class="">
              <div class="">
                <div class="p-3 text-lg font-bold">Chats</div>
              </div>
            </div>
            <div v-if="props.complaintStatus == 'opened'" class="p-2">
              <Button
                class="p-button-sm p-button-outlined"
                icon="pi pi-comment"
                label="Send Message"
                @click="
                  app.openPageDialog({
                    page: 'chats/add',
                    url: `/chats/add/`,
                    pageData: {
                      complaint_id: props.complaintId,
                      customer_name: props.customerName,
                    },
                    closeBtn: true,
                    persistent: true,
                    position: 'bottom',
                    width: '40%',
                  })
                "
              />
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div class="flex align-items-center justify-content-around">
                <div v-if="searchText" :class="filterTagClass">
                  Search
                  <Chip
                    class="font-medium px-2 py-1"
                    removable
                    @remove="clearSearch()"
                    >{{ searchText }}</Chip
                  >
                </div>
              </div>
              <div class="">
                <div>
                  <template v-if="showBreadcrumbs && $route.query.tag">
                    <Breadcrumb
                      :home="{ icon: 'pi pi-home', to: '/chats' }"
                      :model="pageBreadCrumb"
                    />
                  </template>
                  <div class="relative-position">
                    <div class="grid">
                      <!-- Master Page Start -->
                      <div class="col-12">
                        <div class="" :class="{ card: !isSubPage }">
                          <div class="page-records">
                            <div class="grid justify-content-start">
                              <div v-for="(data, i) of records" :key="i">
                                <div class="col-12 md:col-12">
                                  <div class="flex flex-col space-y-4 p-0">
                                    <div
                                      v-if="data.participant_type == 'customer'"
                                      class="chat-message mb-1"
                                    >
                                      <div class="">
                                        <Chip
                                          :label="data.message"
                                          class="mr-2 mb-2"
                                        />
                                        <div class="text-sm text-500">
                                          {{
                                            $utils.relativeDate(
                                              data.date_created
                                            )
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                    <div v-else class="chat-message mb-1">
                                      <div class="flex justify-content-end">
                                        <div class="">
                                          <Chip
                                            :label="data.message"
                                            class="mr-2 mb-2 custom-chip"
                                          />
                                          <div
                                            class="text-sm text-500 text-right"
                                          >
                                            <Button
                                              class="p-button-link p-0 text-left"
                                              icon=""
                                              label="Edit"
                                              v-if="data.chat_id"
                                              @click="
                                                app.openPageDialog({
                                                  page: 'chats/edit',
                                                  url: `/chats/edit/${data.chat_id}`,
                                                  closeBtn: true,
                                                  persistent: true,
                                                  position: 'bottom',
                                                  width: '30%',
                                                })
                                              "
                                            />
                                            •
                                            {{
                                              $utils.relativeDate(
                                                data.date_created
                                              )
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- page loading indicator -->
                          <template v-if="loading">
                            <div>
                              <table class="p-datatable-table w-full">
                                <tbody>
                                  <tr v-for="n in 2" :key="n">
                                    <div class="custom-skeleton p-1">
                                      <div class="flex mb-3">
                                        <Skeleton
                                          width="70%"
                                          height="2rem"
                                          borderRadius="16px"
                                        ></Skeleton>
                                      </div>
                                      <div
                                        class="flex justify-content-end mt-3"
                                      >
                                        <Skeleton
                                          width="70%"
                                          borderRadius="16px"
                                          height="2rem"
                                        ></Skeleton>
                                      </div>
                                    </div>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </template>
                          <!-- end of page loading indicator-->
                          <!-- Empty record -->
                          <template v-if="pageReady && !records.length">
                            <div
                              class="p-3 my-3 text-500 text-md font-medium text-center"
                            >
                              No messages found
                            </div>
                          </template>
                          <!-- end of empty record-->
                          <!-- pagination component-->
                          <template v-if="showFooter">
                            <div class="">
                              <div class="flex justify-content-between">
                                <div class="flex-grow-0">
                                  <div class="flex"></div>
                                </div>
                                <div class="flex-grow-1">
                                  <div class="m-2 text-center">
                                    <Button
                                      v-if="canLoadMore && totalPages > 1"
                                      @click="loadNextPage()"
                                      class="p-button-sm"
                                      label="Load More"
                                    />
                                    <div
                                      class="text-sm text-gray-500"
                                      v-if="
                                        finishedLoading &&
                                        records.length > recordCount
                                      "
                                    >
                                      No more content to load
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <!-- end of pagination component-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { reactive, toRefs, onMounted } from "vue";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { useListPage } from "@/composables/listpage.js";
const props = defineProps({
  primaryKey: {
    type: String,
    default: "chat_id",
  },
  pageName: {
    type: String,
    default: "chats",
  },
  routeName: {
    type: String,
    default: "chatslist",
  },
  apiPath: {
    type: String,
    default: "chats/index",
  },
  paginate: {
    type: Boolean,
    default: true,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  showBreadcrumbs: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  importButton: {
    type: Boolean,
    default: false,
  },
  multiCheckbox: {
    type: Boolean,
    default: false,
  },
  emptyRecordMsg: {
    type: String,
    default: "No messages found",
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Are you sure you want to delete this record?",
  },
  msgAfterDelete: {
    type: String,
    default: "Message deleted successfully",
  },
  page: {
    type: Number,
    default: 1,
  },
  limit: {
    type: Number,
    default: 5,
  },
  mergeRecords: {
    // for infinite loading
    type: Boolean,
    default: true,
  },
  search: {
    type: String,
    default: "",
  },
  fieldName: null,
  fieldValue: null,
  complaintId: null,
  complaintStatus: null,
  customerName: null,
  sortBy: {
    type: String,
    default: "",
  },
  sortType: {
    type: String,
    default: "", //desc or asc
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  filterTagClass: {
    type: String,
    default:
      "surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-center",
  },
});
const app = useApp();
const auth = useAuth();
const filters = reactive({});
//init list page hook
const page = useListPage(props, filters);
//page state
const {
  totalRecords, // total records from api - Number
  recordCount, // current record count - Number
  loading, // Api loading state - Boolean
  selectedItems, // Data table selected items -Array
  pagination, //Pagination object - Object
  searchText, // search text - String
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  records, // page record from store - Array
  apiUrl, // current api path - URL
  currentRecord, // master detail selected record - Object
  pageBreadCrumb, // get page navigation paths - Object
  canLoadMore, // if api has more data for loading - Boolean
  finishedLoading, // if api has finished loading - Boolean
  totalPages, // total number of pages from api - Number
  recordsPosition, // current record position from api - Number
} = page.computedProps;
//page methods
const {
  load, // load data from api
  reload, // reset pagination and load data
  loadNextPage, // load next page
  loadPreviousPage, // load previous page
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  clearSearch, // clear input search
  debounce, // debounce input search
  onSort, // reset page number before sort from api
  deleteItem, // delete item by id or selected items - args = (id) or (selectedItems)
  setCurrentRecord, // master detail set current record
  isCurrentRecord, // master detail
  removeFilter, // remove page filter item - args = (filter.propertyname)
  getFilterLabel, // get filter item display label - args = (filter.propertyname)
  filterHasValue, //check if filter item has value - args = (filter.propertyname)
  importComplete, // reload page after data import
} = page.methods;

onMounted(() => {
  const pageTitle = "Chats";
  app.setPageTitle(props.routeName, pageTitle);
  load();
});
</script>
<style scoped>
.flex-col {
  flex-direction: column;
}
.p-chip.custom-chip {
  background: var(--purple-400);
  color: var(--primary-color-text);
}
</style>
